import { PureComponent } from 'react';
import PubSub from 'pubsub-js';

import pushwooshPropTypes from 'core/utils/prop-types/pushwoosh';
import loadScript from 'core/utils/load-script';

import withoutSSR from 'core/components/withoutSSR';

import { STORIES_MODAL_STATE } from 'core/components/stories/constants';

export function initPushWoosh(options, initAction) {
  if (window.Pushwoosh && window.Pushwoosh.ready) return;

  if (!options) {
    console.warn('Pushwoosh doesn\'t have necessary init options');
    return;
  }

  loadScript('https://cdn.pushwoosh.com/webpush/v3/pushwoosh-web-notifications.js', 'pushwoosh-web-notifications')
    .then(() => {
      window.Pushwoosh = window.Pushwoosh || [];
      window.Pushwoosh.push(['init', {
        autoSubscribe: true,
        logLevel: 'error',
        ...options,
      }]);
    })
    .then(() => {
      initAction && window.Pushwoosh.push(api => {
        /**
         * Устанавливаем тег, для сбора статистики в админке PushWoosh, о показе предложения подписаться:
         *
         * - timeout_30 - по истечению 30 секунд проведенных на сайте
         * - page_read - по прочтению статьи
         * - stories_viewed - по закрытию модального окнка StoryWidgets
         */
        api.setTags({ initAction });
      });
    });
}

class PushWoosh extends PureComponent {
  static contextTypes = {
    pushWoosh: pushwooshPropTypes,
  };

  componentDidMount() {
    if (window.Pushwoosh) return;

    this.timer = setTimeout(() => {
      initPushWoosh(this.context.pushWoosh, 'timeout_30');
    }, 1000 * 30);

    this.lazyForStories();
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    this.storiesModalStateSubscription && PubSub.unsubscribe(this.storiesModalStateSubscription);
  }

  lazyForStories = () => {
    this.storiesModalStateSubscription = PubSub.subscribe(STORIES_MODAL_STATE, (eventName, { opened }) => {
      if (opened) {
        clearTimeout(this.timer);
        return;
      }

      initPushWoosh(this.context.pushWoosh, 'stories_viewed');
    });
  };

  render() {
    return null;
  }
}

export default withoutSSR(PushWoosh);
